import React, { useState } from 'react';
import Modal from 'react-modal';
import moment from 'moment';
import {
  toWeekStartDate,
  toWeekInt,
  toWeekString,
} from '../../../helpers/moment';
import UploadFile from '../../../components/Input/UploadFile';
import { config } from '../../../config/index';
const { API_URL } = config;

const UploadTimesheet = ({ activeWeek, activeClient, activeSite }) => {
  const [showModal, setShowModal] = useState(false);
  const [modalResponseError, setModalResponseError] = useState('');
  const padding = 90; // adjust this to your needs
  let height = 375 + padding;
  let heightPx = height + 'px';
  let heightOffset = height / 2;
  let offsetPx = heightOffset + 'px';

  const style = {
    border: '0',
    borderRadius: '20px',
    bottom: 'auto',
    height: heightPx, // set height
    left: '50%',
    padding: '2rem',
    position: 'fixed',
    right: 'auto',
    top: '50%', // start from center
    transform: 'translate(-50%,-' + offsetPx + ')', // adjust top "up" based on height
    width: '50%',
    maxWidth: '50rem',
  };

  const type = localStorage.getItem('type');
  let startWeek = toWeekStartDate(moment(), activeClient?.start_day || 0);

  const handleOpenModal = async () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setModalResponseError('');
    setShowModal(false);
  };
  return (
    <React.Fragment>
      {type !== 'client' &&
        activeClient &&
        moment(activeWeek.startDate).isSameOrAfter(
          startWeek.subtract(1, 'days')
        ) && (
          <>
            <div
              className="adjust-card-shadow mb-4 px-4 d-flex flex-row justify-content-between align-items-center"
              style={{
                height: '120px',
                borderLeft: ' 10px solid #1179f7',
                marginRight: '1rem',
              }}
            >
              <div className="d-flex flex-column" style={{ width: '70%' }}>
                <h6 className="adjust-upload-title">Timesheet Upload</h6>
                <p className="text-muted adjust-upload-description">
                  Upload weekly associate timesheet
                </p>
              </div>
              <button
                type="button"
                disabled={false}
                onClick={handleOpenModal}
                className="btn btn-outline-brand adjust-btn-shadow px-4"
              >
                Open
              </button>
            </div>
            {activeClient && activeSite && (
              <Modal
                ariaHideApp={false}
                isOpen={showModal}
                style={{
                  overlay: { backgroundColor: 'rgba(0, 0, 0, 0.5)' },
                  content: style,
                }}
              >
                {activeWeek.startDate && activeWeek.endDate && (
                  <React.Fragment>
                    <h5>
                      {activeSite.name} - Upload Timesheet Attendance Week{' '}
                      {toWeekInt(activeWeek.startDate, activeClient.start_day)},{' '}
                      {toWeekString(activeWeek.endDate, activeClient.start_day)}
                    </h5>
                    {modalResponseError && (
                      <div>
                        <label
                          style={{
                            color: '#f83232',
                            paddingTop: 11,
                            fontWeight: 700,
                          }}
                        >
                          Results:
                        </label>
                        <p className="mb-4 ms-2" style={{ color: '#f84949' }}>
                          {modalResponseError}
                        </p>
                      </div>
                    )}
                    <p className="text-muted">Drag and drop your file here</p>

                    <UploadFile
                      url={`${API_URL}/site/${activeSite.id}/timesheet/upload`}
                      otherData={{ hours: 1 }}
                      handleCloseModal={handleCloseModal}
                      template={'templates/upload_timesheet_template.csv'}
                      setModalResponseError={setModalResponseError}
                    />
                  </React.Fragment>
                )}
              </Modal>
            )}
          </>
        )}
    </React.Fragment>
  );
};

export default UploadTimesheet;
